import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { Box, Container, Typography, AppBar, Toolbar, Button, Tabs, Tab } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { styled } from '@mui/material/styles';

// 管理者のメールアドレス
const ADMIN_EMAIL = 'reiji.01101114@gmail.com';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: '1px solid rgba(0, 255, 255, 0.2)',
  '& .MuiTabs-indicator': {
    backgroundColor: '#00ffff',
    height: 3,
    boxShadow: '0 0 10px #00ffff',
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 0,
  marginRight: theme.spacing(3),
  fontWeight: 500,
  fontSize: '0.95rem',
  color: 'rgba(255, 255, 255, 0.7)',
  '&:hover': {
    color: '#00ffff',
    opacity: 1,
  },
  '&.Mui-selected': {
    color: '#00ffff',
    fontWeight: 600,
  },
}));

const AdminLayout = () => {
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const location = useLocation();

  // タブの値を取得
  const getTabValue = () => {
    if (location.pathname.includes('/admin/drafts')) return 1;
    if (location.pathname.includes('/admin/tournament-names')) return 2;
    if (location.pathname.includes('/admin/team-names')) return 3;
    return 0; // デフォルトはトーナメント管理
  };

  // タブ変更時の処理
  const handleTabChange = (event, newValue) => {
    switch (newValue) {
      case 0:
        navigate('/admin/tournaments');
        break;
      case 1:
        navigate('/admin/drafts');
        break;
      case 2:
        navigate('/admin/tournament-names');
        break;
      case 3:
        navigate('/admin/team-names');
        break;
      default:
        break;
    }
  };

  // 未ログインまたは管理者以外のユーザーはアクセス不可
  if (!user || user.email !== ADMIN_EMAIL) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar 
        position="fixed" 
        sx={{ 
          bgcolor: 'background.paper',
          borderBottom: 1,
          borderColor: 'grey.200',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
            <Button
              component={Link}
              to="/"
              startIcon={<ArrowBackIcon />}
              sx={{ 
                color: 'text.primary',
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              戻る
            </Button>
            <Typography 
              variant="h6" 
              component="div" 
              sx={{ 
                flexGrow: 1,
                color: 'text.primary',
                fontWeight: 600
              }}
            >
              Tournament Tracker 管理画面
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'grey.50',
          mt: 8,
          py: 4
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ mb: 3 }}>
            <StyledTabs 
              value={getTabValue()} 
              onChange={handleTabChange}
              sx={{ 
                bgcolor: 'rgba(37, 37, 48, 0.9)',
                borderRadius: 0,
                px: 2,
                boxShadow: '0 0 20px rgba(0, 255, 255, 0.1)',
              }}
            >
              <StyledTab label="トーナメント管理" />
              <StyledTab label="下書き管理" />
              <StyledTab label="大会名管理" />
              <StyledTab label="チーム名管理" />
            </StyledTabs>
          </Box>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default AdminLayout;
